module.exports = __webpack_public_path__ + "img/a5fd239.png";